module.exports = __webpack_public_path__ + "img/body_bottom_bg.33d490e0.png";